<template>
  <section class="pb-[80px] xl:pb-[160px]">
    <SectionTitle
      title-class="!mb-8"
      class="!items-start"
      :title="$t('landing.ourHistory.title')"
    />
    <div class="space-y-4 font-openSans">
      <p>
        {{ $t("landing.ourHistory.description") }}
      </p>
      <p>
        {{ $t("landing.ourHistory.description2") }}
      </p>
      <p>
        {{ $t("landing.ourHistory.description3") }}
      </p>
      <p>
        {{ $t("landing.ourHistory.description4") }}
      </p>
      <p>
        {{ $t("landing.ourHistory.description5") }}
      </p>
    </div>
    <CommonHistoryModal />
  </section>
</template>

<script setup lang="ts">
import SectionTitle from "@/modules/Landing/components/Common/SectionTitle.vue";
</script>

<style scoped></style>
